import React from "react";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import SecurityIcon from "@mui/icons-material/Security";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import LanguageIcon from "@mui/icons-material/Language";
import CloudQueueIcon from "@mui/icons-material/CloudQueue";
import SpeedIcon from "@mui/icons-material/Speed";
import GroupIcon from "@mui/icons-material/Group";
import { acme } from "../../theme/acmeTheme";

const publicBase = process.env.PUBLIC_URL || "";
const iconSx = { color: acme.colors.brand, fontSize: 28 };

export const aboutValues = [
  {
    icon: <TrendingUpIcon sx={iconSx} />,
    title: "Innovation First",
    description:
      "We constantly push the boundaries of email marketing technology to deliver cutting-edge solutions.",
  },
  {
    icon: <SecurityIcon sx={iconSx} />,
    title: "Security & Privacy",
    description:
      "Your data security is our top priority. We maintain the highest standards of data protection.",
  },
  {
    icon: <SupportAgentIcon sx={iconSx} />,
    title: "24/7 Support",
    description:
      "Our dedicated support team is always ready to help you succeed with your email campaigns.",
  },
  {
    icon: <LanguageIcon sx={iconSx} />,
    title: "Global Reach",
    description:
      "Serving businesses worldwide with localized support and compliance in every region.",
  },
];

export const aboutStats = [
  { number: "1,000+", label: "Active Users", icon: <GroupIcon /> },
  { number: "99.9%", label: "Uptime", icon: <CloudQueueIcon /> },
  { number: "100M+", label: "Emails Sent", icon: <SpeedIcon /> },
  { number: "15+", label: "Countries", icon: <LanguageIcon /> },
];

export const aboutTeam = [
  {
    name: "Aleksandr Khrustalov",
    role: "CEO & Founder",
    description: "6+ years in web development",
    avatar: `${publicBase}/images/aleksandr_khrustalov.png`,
    skills: [
      "Strategy",
      "Leadership",
      "Architecture",
      "payload",
      "next.js",
      "tailwindcss",
      "typescript",
      "html",
      "css",
      "scss",
      "javascript",
      "react",
      "node.js",
      "express",
      "mongodb",
      "mysql",
      "postgresql",
      "docker",
      "DevOps",
      "AI/ML",
      "Project Management",
      "Team Leadership",
      "UX/UI",
      "Graphic Design",
    ],
  },
  {
    name: "Aleksandr Rjabov",
    role: "Business Development",
    description: "8+ years in business development",
    avatar: `${publicBase}/images/aleksandr_rjabov.jpeg`,
    skills: [
      "Business Development",
      "Sales",
      "Marketing",
      "Project Management",
      "Team Leadership",
      "GTM",
      "Strategy Development",
      "Telecom infrastructure",
      "Technical presales",
      "Sales Management",
      "Complex negotiations",
      "C-level communication",
      "Problem-solving",
      "Strategic networking",
    ],
  },
];
